module.exports = __webpack_public_path__ + "static/media/community-partner-third.940d5ee7.jpg";